import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

if (!customElements.get('shade-chart')) {
    class ShadeChart extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.elSwiper = this.querySelector('[data-carousel]');
            this.elImages = this.querySelectorAll('[data-image]');
            this.elSkintoneSelector = this.querySelector('custom-select');

            this.filterImages(this.getSelectedSkintone());
            this.elSkintoneSelector.addEventListener('change', (ev) => {
                this.filterImages(ev.target.value);
            });
        }

        getSelectedSkintone() {
            const checked = this.elSkintoneSelector.querySelector('input:checked');
            return this.elSkintoneSelector.value || checked?.value || this.elImages[0]?.dataset.skintone;
        }
        
        filterImages(skintone) {
            this.elImages.forEach(el => el.toggleAttribute('hidden', el.dataset.skintone != skintone));
            this.initSwiper();
        }

        initSwiper() {
            if (!this.elSwiper) return;
            this.swiper && this.swiper.destroy();
            this.swiper = new Swiper(this.elSwiper, {
                loop: false,
                slidesPerView: 'auto',
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24,
                spaceBetween: 0,
                breakpoints: {
                    1024: {
                        slidesOffsetBefore: 40,
                        slidesOffsetAfter: 40
                    }
                }
            })
        }
    }

    customElements.define('shade-chart', ShadeChart);
}
